import React from 'react';
import Icon from '../../../components/AppIcon';

const DocumentStatusBadge = ({ status, daysUntilExpiry }) => {
  const getStatusConfig = () => {
    if (status === 'no-expiry') {
      return {
        label: 'No expiry date',
        icon: 'Minus',
        bgColor: 'bg-muted',
        textColor: 'text-muted-foreground',
        iconColor: 'var(--color-muted-foreground)'
      };
    }

    if (status === 'expired') {
      return {
        label: 'Expired',
        icon: 'XCircle',
        bgColor: 'bg-error/10',
        textColor: 'text-error',
        iconColor: 'var(--color-error)'
      };
    }

    if (status === 'expiring-soon' || status === 'expiring-critical') {
      const days = typeof daysUntilExpiry === 'number' ? daysUntilExpiry : null;
      return {
        label: days !== null ? `Expires in ${days} day${days !== 1 ? 's' : ''}` : 'Expiring Soon',
        icon: days !== null && days <= 14 ? 'AlertTriangle' : 'AlertCircle',
        bgColor: days !== null && days <= 14 ? 'bg-error/10' : 'bg-warning/10',
        textColor: days !== null && days <= 14 ? 'text-error' : 'text-warning',
        iconColor: days !== null && days <= 14 ? 'var(--color-error)' : 'var(--color-warning)'
      };
    }

    return {
      label: 'Valid',
      icon: 'CheckCircle2',
      bgColor: 'bg-success/10',
      textColor: 'text-success',
      iconColor: 'var(--color-success)'
    };
  };

  const config = getStatusConfig();

  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md ${config?.bgColor}`}>
      <Icon name={config?.icon} size={14} color={config?.iconColor} />
      <span className={`text-xs font-medium ${config?.textColor}`}>{config?.label}</span>
    </div>
  );
};

export default DocumentStatusBadge;